interface EditorPanelAssetsListOptions {}
import {ref, Ref} from '@vue/composition-api';
export class EditorPanelAssetsListStoreControllerClass {
	private static _instance: EditorPanelAssetsListStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelAssetsListStoreControllerClass());
	}

	private constructor() {}

	private _displayed!: Ref<boolean>;
	init() {
		this._displayed = ref(false);
	}

	displayed(): boolean {
		return this._displayed.value;
	}

	// mutations
	open(options?: EditorPanelAssetsListOptions): void {
		this._displayed.value = true;
	}
	close() {
		this._displayed.value = false;
	}
}

export const EditorPanelAssetsListStoreController = EditorPanelAssetsListStoreControllerClass.instance();
